import * as React from 'react'
import cx from 'classnames'
import styles from './ScrollView.sass'

interface ScrollViewProps extends React.RefAttributes<HTMLDivElement> {
  children?: React.ReactNode
  maxHeight?: number
}

export default React.forwardRef(function ScrollView(
  { children, maxHeight }: ScrollViewProps,
  ref: React.Ref<HTMLDivElement>
) {
  const maxHeightStyles = maxHeight ? { maxHeight } : {}

  return (
    <div ref={ref} style={maxHeightStyles} className={cx(styles.root)}>
      {children}
    </div>
  )
})
